import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, CrownIcon } from 'lucide-react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila', 'Fernanda', 'Alejandro', 'Gabriela', 'José', 'Paola'];
const COUNTRIES = ['Argentina 🇦🇷', 'México 🇲🇽', 'Colombia 🇨🇴', 'Chile 🇨🇱', 'Perú 🇵🇪', 'Ecuador 🇪🇨', 'Uruguay 🇺🇾', 'Paraguay 🇵🇾', 'Costa Rica 🇨🇷', 'Panamá 🇵🇦', 'Guatemala 🇬🇹', 'República Dominicana 🇩🇴', 'Bolivia 🇧🇴', 'Honduras 🇭🇳', 'El Salvador 🇸🇻'];
const PRODUCT = 'Pack Completo';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: '',
    product: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentPurchase({
        name: randomName,
        country: randomCountry,
        product: PRODUCT
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(() => {
      showPopup();
    }, Math.floor(Math.random() * 4000) + 8000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const isCompleto = currentPurchase.product === 'Pack Completo';
  return <AnimatePresence data-id="element-186">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100,
      y: 20
    }} className={`fixed bottom-4 left-4 z-50 max-w-sm rounded-lg shadow-2xl p-4 flex items-start gap-3 ${isCompleto ? 'bg-gradient-to-br from-yellow-50 to-amber-50 border-2 border-yellow-400 shadow-[0_0_20px_rgba(250,204,21,0.3)]' : 'bg-white border border-gray-200'}`} data-id="element-187">
          <div className="mt-1 flex-shrink-0" data-id="element-188">
            {isCompleto ? <CrownIcon className="w-6 h-6 text-yellow-500" data-id="element-189" /> : <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-190" />}
          </div>
          <div data-id="element-191">
            <p className="text-sm text-gray-800" data-id="element-192">
              <span className="font-bold" data-id="element-193">{currentPurchase.name}</span> de{' '}
              <span className="font-bold" data-id="element-194">{currentPurchase.country}</span> acaba
              de comprar el
            </p>
            <p className={`text-sm font-bold mt-1 ${isCompleto ? 'text-yellow-600' : 'text-blue-600'}`} data-id="element-195">
              {isCompleto && '🏆 '}
              {currentPurchase.product}!
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-196">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}